import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPen24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPen24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m20.107 6.107-1.632-1.632a.5.5 0 0 0-.708 0L16.34 5.903l2.34 2.34 1.428-1.429a.5.5 0 0 0 0-.707M6.254 15.988l9.025-9.024 2.339 2.339-9.025 9.025-3 .66zm3.09 3.71L21.167 7.875a2 2 0 0 0 0-2.829l-1.632-1.632a2 2 0 0 0-2.828 0L4.883 15.238l-.922 4.192a1 1 0 0 0 1.191 1.191zm5.406-.198a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPen24);
